export const FUND_CONFIRMATION =
  'Do you hereby confirm that all of this uploaded data is self-reported, accurate, and complete and that Apex US Distribution LLC is neither verifying nor responsible for the accuracy of this uploaded data?'
